import type { IHttpRequestRunner } from 'shared/domain/httpRequest/httpRequestRunner';
import {
  InspectionHttpCreateRequestModel,
  InspectionHttpDeleteRequestModel,
  InspectionHttpEditRequestModel,
  InspectionHttpRestoreRequestModel,
} from './types';
import { Fetcher } from '../fetcher';
import { InspectionInDto } from 'shared/dtos/in/inspection';

type InspectionHttpRequestModel =
  | InspectionHttpCreateRequestModel
  | InspectionHttpEditRequestModel
  | InspectionHttpDeleteRequestModel
  | InspectionHttpRestoreRequestModel;

export class InspectionRequestRunner implements IHttpRequestRunner {
  constructor(
    private fetcher: typeof Fetcher,
    private updateDeleted: (
      inspectionId: string,
      deleted: 0 | 1
    ) => Promise<unknown>
  ) {}

  async execute(
    request: InspectionHttpRequestModel
  ): Promise<InspectionInDto | boolean> {
    switch (request.method) {
      case 'POST': {
        return this.createInspection(
          request as InspectionHttpCreateRequestModel
        );
      }
      case 'PUT': {
        return this.updateInspection(
          request as InspectionHttpEditRequestModel
        );
      }
      case 'DELETE': {
        return this.deleteInspection(
          request as InspectionHttpDeleteRequestModel
        );
      }
      case 'GET': {
        return this.restoreInspection(
          request as InspectionHttpRestoreRequestModel
        );
      }
    }
  }

  private async createInspection(
    request: InspectionHttpCreateRequestModel
  ): Promise<InspectionInDto> {
    const response = await this.fetcher.POST(
      request.url,
      request.data.inspectionOutDto
    );
    return response as InspectionInDto;
  }

  private async updateInspection(
    request: InspectionHttpEditRequestModel
  ): Promise<InspectionInDto> {
    const response = await this.fetcher.PUT(
      request.url,
      request.data.inspectionOutDto
    );
    return response as InspectionInDto;
  }

  private async deleteInspection(
    request: InspectionHttpDeleteRequestModel
  ): Promise<boolean> {
    await this.fetcher.DELETE(request.url);
    await this.updateDeleted(request.data.inspectionId, 1);
    return true;
  }

  private async restoreInspection(
    request: InspectionHttpRestoreRequestModel
  ): Promise<boolean> {
    await this.fetcher.GET(request.url);
    await this.updateDeleted(request.data.inspectionId, 0);
    return true;
  }
}
